/** Multi-select dialog for SpamAssassin ok_locales character-set codes. */
/** Native SpamAssassin ok_locales values (charset families, not TextCat languages). */
export const OK_LOCALE_OPTIONS = [
    { code: "all", label: "All locales" },
    { code: "en", label: "Western character sets" },
    { code: "ja", label: "Japanese" },
    { code: "ko", label: "Korean" },
    { code: "ru", label: "Cyrillic" },
    { code: "th", label: "Thai" },
    { code: "zh", label: "Chinese" },
];
function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className)
        node.className = className;
    if (text !== undefined)
        node.textContent = text;
    return node;
}
function parseLocaleCodes(value) {
    const known = new Set(OK_LOCALE_OPTIONS.map((opt) => opt.code));
    const selected = new Set();
    for (const part of value.trim().toLowerCase().split(/\s+/)) {
        if (part && known.has(part)) {
            selected.add(part);
        }
    }
    return selected;
}
export function formatOkLocales(codes) {
    const knownOrder = OK_LOCALE_OPTIONS.map((opt) => opt.code);
    const selected = new Set([...codes].map((code) => code.trim().toLowerCase()).filter(Boolean));
    if (selected.has("all")) {
        return "all";
    }
    return knownOrder.filter((code) => code !== "all" && selected.has(code)).join(" ");
}
export function showOkLocalesPicker(root, currentValue) {
    return new Promise((resolve) => {
        root.querySelector(".locale-picker-overlay")?.remove();
        const selected = parseLocaleCodes(currentValue);
        if (selected.size === 0) {
            selected.add("en");
        }
        const overlay = el("div", "confirm-overlay locale-picker-overlay");
        const dialog = el("div", "confirm-dialog card locale-picker-dialog");
        dialog.setAttribute("role", "dialog");
        dialog.setAttribute("aria-modal", "true");
        dialog.setAttribute("aria-labelledby", "ok-locales-picker-title");
        const title = el("h2", "confirm-title", "OK Locales");
        title.id = "ok-locales-picker-title";
        const hint = el("p", "hint", "Choose which character-set families are allowed. Mail in other locales may score as foreign-language spam.");
        const list = el("div", "locale-picker-list");
        const checkboxes = new Map();
        const syncExclusive = (changed) => {
            if (changed === "all" && checkboxes.get("all")?.checked) {
                for (const [code, input] of checkboxes) {
                    if (code !== "all") {
                        input.checked = false;
                    }
                }
                return;
            }
            if (changed !== "all" && checkboxes.get(changed)?.checked) {
                const allBox = checkboxes.get("all");
                if (allBox) {
                    allBox.checked = false;
                }
            }
        };
        for (const opt of OK_LOCALE_OPTIONS) {
            const row = el("label", "checkbox-label locale-picker-row");
            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.value = opt.code;
            checkbox.checked = selected.has(opt.code);
            checkbox.addEventListener("change", () => syncExclusive(opt.code));
            checkboxes.set(opt.code, checkbox);
            row.append(checkbox, document.createTextNode(`${opt.label} (${opt.code})`));
            list.append(row);
        }
        const actions = el("div", "confirm-actions");
        const cancel = el("button", "btn btn-secondary", "Cancel");
        cancel.type = "button";
        const apply = el("button", "btn btn-primary", "Apply");
        apply.type = "button";
        const close = (result) => {
            overlay.remove();
            resolve(result);
        };
        cancel.addEventListener("click", () => close(null));
        apply.addEventListener("click", () => {
            const codes = [...checkboxes.entries()]
                .filter(([, input]) => input.checked)
                .map(([code]) => code);
            if (codes.length === 0) {
                codes.push("en");
            }
            close(formatOkLocales(codes));
        });
        overlay.addEventListener("click", (event) => {
            if (event.target === overlay) {
                close(null);
            }
        });
        actions.append(cancel, apply);
        dialog.append(title, hint, list, actions);
        overlay.append(dialog);
        root.append(overlay);
        cancel.focus();
    });
}
